export const TabItems = [
  {
    tabName: 'All',
    tabContent: [
      {
        time: '2 min ago',
        iconClass: 'iconoir-wolf',
        title: 'Your order is placed',
        description: 'Dummy text of the printing and industry.',
      },
      {
        time: '10 min ago',
        iconClass: 'iconoir-apple-swift',
        title: 'Meeting with designers',
        description: 'It is a long established fact that a reader.',
      },
      {
        time: '40 min ago',
        iconClass: 'iconoir-birthday-cake',
        title: 'UX 3 Task complete.',
        description: 'Dummy text of the printing.',
      },
      {
        time: '1 hr ago',
        iconClass: 'iconoir-drone',
        title: 'Your order is placed',
        description: 'It is a long established fact that a reader.',
      },
      {
        time: '2 hrs ago',
        iconClass: 'iconoir-user',
        title: 'Payment Successful',
        description: 'Dummy text of the printing.',
      },
    ],
  },
  {
    tabName: 'Projects',
    tabContent: [
      {
        time: '40 min ago',
        iconClass: 'iconoir-birthday-cake',
        title: 'UX 3 Task complete.',
        description: 'Dummy text of the printing.',
      },
      {
        time: '1 hr ago',
        iconClass: 'iconoir-drone',
        title: 'Your order is placed',
        description: 'It is a long established fact that a reader.',
      },
      {
        time: '2 hrs ago',
        iconClass: 'iconoir-user',
        title: 'Payment Successful',
        description: 'Dummy text of the printing.',
      },
    ],
  },
  {
    tabName: 'Team',
    tabContent: [
      {
        time: '1 hr ago',
        iconClass: 'iconoir-drone',
        title: 'Your order is placed',
        description: 'It is a long established fact that a reader.',
      },
      {
        time: '2 hrs ago',
        iconClass: 'iconoir-user',
        title: 'Payment Successful',
        description: 'Dummy text of the printing.',
      },
    ],
  },
]
